<template>
    <!-- <VuePullRefresh :on-refresh="onRefresh"> -->
        <div class="myMessage">
            <annTab :type="3"></annTab>
            <div class="xlXzType">
                <van-field readonly clickable :value="msgType" @click="showPicker = true" />
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
                </van-popup>
                <img class="xlImg" src="../../assets/annOnLine/xlBtn.png" />
            </div>

            <ul v-show="dataFlag" class="msgUl">
                <li class="msgLi" v-for="item in msgList" :key="item.id">
                    <div class="msgTit" v-if="item['content']">
                        <div class="msgContent" @click="goDet(item.id)">{{ item["content"] }}</div>
                        <div class="djDiv">
                            <span class="time">{{ item["strCreateDate"] }}</span>
                            <button class="closeBtn" @click="closeMsg(item.id)" v-if="item.isDel != 1">关闭留言</button>
                        </div>
                    </div>
                </li>
            </ul>
            <div class="notLink" v-show="!dataFlag">
                <img src="../../assets/annOnLine/notLink.png" />
                <p>暂无内容</p>
            </div>
            <div class="inputBox">
                <input v-model="msgTextarea" @keyup.enter="sendMsg" placeholder="请输入您的留言，我们将尽快回复" />
                <button @click="sendMsg">确定</button>
            </div>
        </div>
    <!-- </VuePullRefresh> -->
</template>

<script>
import annTab from "../../components/annTab";
import { Toast } from "vant";
// import VuePullRefresh from "vue-pull-refresh";
export default {
    components: {
        annTab
        // VuePullRefresh
    },
    data() {
        return {
            msgTextarea: "",
            msgList: [],
            dataFlag: true,
            columns: ["全部留言", "已回复留言", "未回复留言", "已关闭留言"],
            showPicker: false,
            msgType: "全部留言",
            lytype: "3",
            page: 0,
            pageFlag: true
        };
    },
    mounted() {
        this.$store.dispatch("actionsHead", { type: true, title: "智能客服", iconType: false });

        this.getData("1");
        //分页
        let that = this;
        window.onscroll = function() {
            //变量scrollTop是滚动条滚动时，距离顶部的距离
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (Math.ceil(scrollTop + windowHeight) == scrollHeight || Math.floor(scrollTop + windowHeight) == scrollHeight) {
                //写后台加载数据的函数
                that.getData();
            }
        };
    },
    methods: {
        //获取留言
        getData() {
            
            // alert('获取全部留言')
            if (!this.pageFlag) {
                return false;
            } else {
                this.page++;
            }
            var url = "?type=" + this.lytype + "&page=" + this.page + "&size=10";
            // alert(this.page+'======page')
            this.$get("https://customer.yuntsg.com/leave-message-front/all" + url).then((res) => {
                if (res["code"] == 0 && res["data"]["list"]) {
                    this.dataFlag = true;

                    if (res["data"]["list"].length < 10 ||res["data"]["total"] ==10*this.page) {
                        this.pageFlag = false;
                    }
                    if(this.page==1){
                        this.msgList = res["data"]["list"];
                    }else{
                        this.msgList = this.msgList.concat(res["data"]["list"]);
                    }
                    
                    for (var n in this.msgList) {
                        this.msgList[n]["strCreateDate"] = this.msgList[n]["strCreateDate"].replace("T", "  ");
                        for (var i in this.msgList[n]["ls"]) {
                            this.msgList[n]["ls"][i]["strCreateDate"] = this.msgList[n]["ls"][i]["strCreateDate"].replace("T", "  ");
                        }
                    }
                    // alert(this.msgList)
                    
                } else {
                    this.dataFlag = false;
                }
            });
        },
        //发送留言
        sendMsg() {
            if (this.msgTextarea.split(" ").join("").length == 0) {
                Toast("请输入内容");
                return false;
            }
            // var url = "content=" + this.msgTextarea;
            this.$post("https://customer.yuntsg.com/leave-message-front/ask?content=" + this.msgTextarea).then((res) => {
                if (res["code"] == 0 && res["data"] == 0) {
                    this.msgTextarea = "";
                    this.page = 0;
                    this.pageFlag = true
                    // (this.pageFlag = true), (this.msgList = []);
                    this.msgList = []
                    this.getData();
                    Toast("留言成功");
                }
            });
        },
        goDet(id) {
            this.$router.push({ name: "messageDetails", params: { id: id } });
        },
        onConfirm(value) {
            this.msgType = value;
            this.showPicker = false;
            if (value == "已回复留言") {
                this.lytype = "1";
            } else if (value == "未回复留言") {
                this.lytype = "0";
            } else if (value == "已关闭留言") {
                this.lytype = "2";
            } else if (value == "全部留言") {
                this.lytype = "3";
            }
            this.page = 0;
            (this.pageFlag = true), (this.msgList = []);
            this.getData();
        },
        //关闭留言
        closeMsg(id) {
            var url = "?id=" + id;
            this.$get("https://customer.yuntsg.com/leave-message-front/close" + url).then((res) => {
                if (res["code"] == 0 && res["data"] == 0) {
                    Toast("关闭留言成功");
                    this.page = 0;
                    (this.pageFlag = true), (this.msgList = []);
                    this.getData();
                }
            });
        },
        onRefresh() {
            var url = "?type=" + this.lytype + "&page=1" + "&size=10";
            this.$get("https://customer.yuntsg.com/leave-message-front/all" + url).then((res) => {
                if (res["code"] == 0 && res["data"]["list"]) {
                    this.dataFlag = true;
                    if (res["data"]["list"].length < 10) {
                        this.pageFlag = false;
                    }
                    this.msgList = res["data"]["list"];
                    for (var n in this.msgList) {
                        this.msgList[n]["strCreateDate"] = this.msgList[n]["strCreateDate"].replace("T", "  ");
                        for (var i in this.msgList[n]["ls"]) {
                            this.msgList[n]["ls"][i]["strCreateDate"] = this.msgList[n]["ls"][i]["strCreateDate"].replace("T", "  ");
                        }
                    }
                } else {
                    this.dataFlag = false;
                }
            });
        }
    }
};
</script>
<style lang="less">
.myMessage {
    padding-top:6rem;
    background-color: #ffffff;
    color: #2f2f2f;
    font-size: 0.9rem;
    .xlXzType {
        overflow: hidden;
        .van-cell {
            background-color: transparent !important;
        }
        .van-cell--clickable {
            width: 7rem;
            float: left;
            .van-field__body {
                display: inline-block;
                font-size: 0.9rem;
            }
        }
        .xlImg {
            width: 0.8rem;
            margin-top: 1.3rem;
            margin-left: -1.3rem;
        }
    }
    .msgUl {
        padding: 0.7rem 1rem;
        margin-bottom: 5rem;
        .msgLi {
            border-bottom: 1px dashed #e6e6e6;
            padding: 1rem 0;
            .msgTit {
                overflow: hidden;
                .msgContent {
                    color: #262626;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 1.3rem;
                }
                .djDiv {
                    vertical-align: middle;
                    margin-top: 0.5rem;
                    .time {
                        color: #9c9c9c;
                        padding-top: 0.3rem;
                        font-size: 0.8rem;
                        display: inline-block;
                    }
                    .closeBtn {
                        color: #979797;
                        border: 0.05333rem solid #c1c1c1;
                        padding: 0.1rem 0.3rem 0.2rem 0.3rem;
                        background-color: transparent;
                        float: right;
                        font-size: 0.8rem;
                        border-radius: 0.6rem;
                    }
                }
            }
        }
        .msgLi:last-child {
            border-bottom: none;
        }
    }
    .inputBox {
        width: 100%;
        height: 4rem;
        position: fixed;
        bottom: 0rem;
        left: 0rem;
        border-top: 1px solid #e5e9ee;
        padding: 0.7rem 0 0 1rem;
        background-color: #ffffff;
        input {
            background-color: #f5f5f5;
            height: 2.3rem;
            border-radius: 0.8rem 0 0 0.8rem;
            outline: none;
            border: none;
            padding: 0.5rem;
            width: 80%;
        }
        button {
            border: none;
            background-color: #0689e7;
            color: #ffffff;
            width: 15%;
            height: 2.3rem;
            border-radius: 0 0.8rem 0.8rem 0;
        }
    }
    .notLink {
        text-align: center;
        img {
            width: 10rem;
            margin-bottom: 1.5rem;
            margin-top: 5rem;
        }
        p {
            color: #a5a5a5;
        }
        .goMsg {
            color: #0689e7;
        }
    }
}
</style>
